import React, { useState } from 'react';
import * as ajax from 'lib/axios';
import { ForgetPasswordWrapper } from './styled';
import { ILoginResponse } from 'interfaces/login';
import { Button } from 'antd';
import { message } from 'antd';
import NoLoginFooter from 'components/public-components/no-login-footer';
import { contactEmail } from '@/lib/locale';
import { useModuleTranslation, getTranslator } from '@/i18n/translation';
import { AxiosError } from 'axios';

const Login = () => {
  const [email, setEmail] = useState<string>('');
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const t = useModuleTranslation('password');
  const t2 = getTranslator();

  const onSubmit = async (e: React.MouseEvent) => {
    postRequest();
  };

  const postRequest = async () => {
    setIsLoading(true);
    if (isEmailValid && email && username) {
      try {
        await ajax.handle.post<ILoginResponse>('/forget-password', { username, email });
        message.success(t.receive);
        setIsLoading(false);
      } catch (e) {
        if ((e as AxiosError).code === 'REFUSE') {
          message.error(t2('password', { contactEmail }).ops);
        } else {
          message.error(t.wrong);
        }
      }
    } else {
      message.error(t.wrong);
    }
    setIsLoading(false);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    const isValidEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value);
    if (!isValidEmail && e.target.value !== '') {
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }
  };

  const handleUserNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };

  return (
    <ForgetPasswordWrapper>
      <div className="card">
        <div className="form-title">
          <div>{t.forget}</div>
          <div className="">{t.noWorry}</div>
        </div>
        <div className="message">{t.tip2}</div>
        <div className="form-group">
          {/* {!isEmailValid && <div className="error-message">Invalid User Name</div>} */}
          <input
            placeholder={t.your}
            type="text"
            // className={isEmailValid ? '' : 'error'}
            value={username}
            onChange={handleUserNameChange}
          />
          <label>{t.userName}</label>
          {username && (
            <span className="clear" onClick={() => setUsername('')}>
              ×
            </span>
          )}
        </div>
        <div className="form-group">
          {!isEmailValid && <div className="error-message">{t.invalid}</div>}
          <input
            placeholder="example@gmail.com"
            type="email"
            className={isEmailValid ? '' : 'error'}
            value={email}
            onChange={handleEmailChange}
          />
          <label>{t.email}</label>
          {email && (
            <span className="clear" onClick={() => setEmail('')}>
              ×
            </span>
          )}
        </div>
        <div className="action-button">
          <Button type="primary" onClick={onSubmit} loading={isLoading}>
            {t.send}
          </Button>
        </div>
      </div>
      <NoLoginFooter />
    </ForgetPasswordWrapper>
  );
};

export default Login;
